import { Box, Typography } from '@mui/material';
import styles from './styles.module.css';
import { useEffect, useState } from 'react';
import BollywoodCasinoimg from '../../../images/BollywoodCasino/bollywood casino.png';
import { useLocation } from 'react-router-dom';
import FooterLinks from '../FooterLinks';
import GameScreen from './GameScreen';
import   FlipClock from  "../../FlipClock/FlipClock"
import useCasinoBetplace from '../../../api/useCasinoBetplace';

import RoundLoader from '../../Loader/RoundLoader';

function BollywoodCasino({ onBetSelect, locked, socketData, settledData, gameId = 8,hookExposureData }) {
  const [betDialogOpen, setBetDialogOpen] = useState(false);
  const [selectedBet, setSelectedBet] = useState(null);
 const remainingTime = socketData?.remainingTime
 
     const roundId   = socketData?.roundId
   

const [exposureData, setExposureData] = useState(null);

useEffect(() => {
    if (hookExposureData === null) {
        setExposureData(null);
        return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
        setExposureData(hookExposureData);
    }
}, [hookExposureData, gameId]);
useEffect(() => {
  if (roundId) {
    setExposureData(null);
  }
}, [roundId]);

const exposureKeyMap = {
  DON: 'ifDonWins',
  AMAR_AKBAR_ANTHONY: 'ifAAAWins',
  SAHIB_BIBI_AUR_GHULAM: 'ifSBAGWins',
  DHARAM_VEER: 'ifDharamVeerWins',
  KIS_KISKO_PYAAR_KAROON: 'ifKKKPKWins',
  GHULAM: 'ifGhulamWins',
  ODD: 'ifOdd',
  RED: 'ifRed',
  BLACK: 'ifBlack',
  CARD_A: 'ifCardA',
  CARD_J: 'ifCardJ',
  CARD_Q: 'ifCardQ',
  CARD_K: 'ifCardK',
  dulha_dulhan: 'dulhaDulhan',
  barati: 'barati',
};

const getExposureValue = (selection) => {
  if (!exposureData || !selection) return null;

  const field =
    exposureKeyMap[selection] ??
    exposureKeyMap[selection.toString().toUpperCase()] ??
    selection;
  const val = exposureData[field];
  if (val === undefined || val === null || val === 0) return null;
  return val;
};

 const ExposureLabel = ({ value }) => {
   if (value === null || value === undefined) return null;
   return (
     <Typography sx={{
       fontSize: '11px',
       fontWeight: 600,
       color: value < 0 ? '#ff4444' : '#00c853',
       textAlign: 'center',
       mt: '2px',
       lineHeight: 1,
     }}>
       {value}
     </Typography>
   );
 };

  const buttonData = [
    { label: 'Dulha Dulhan K-Q', odds: '1.97', betType: 'dulha_dulhan' },
    { label: 'Barati J-A', odds: '1.97', betType: 'barati' },
    {
      odds: '1.97',
      betType: 'red',  // Assuming diamond/heart SVG represents 'red'
      label: (
        <Box display="flex" justifyContent="center" gap={1}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M16 8L8 16L0 8L8 0L16 8Z" fill="url(#paint0_linear_7166_23245)" />
            <defs>
              <linearGradient id="paint0_linear_7166_23245" x1="3.336" y1="3.99543" x2="11.2419" y2="13.219" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FE5B42" />
                <stop offset="1" stopColor="#BA0000" />
              </linearGradient>
            </defs>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.7305 1.44C13.0378 -0.48 10.3174 -0.48 8.62468 1.44L8 2.14857L7.37531 1.44C5.68262 -0.48 2.96222 -0.48 1.26952 1.44C-0.423174 3.36 -0.423174 6.44571 1.26952 8.36571L8 16L14.7305 8.36571C16.4232 6.44571 16.4232 3.33714 14.7305 1.44Z" fill="url(#paint0_linear_7166_23246)" />
            <defs>
              <linearGradient id="paint0_linear_7166_23246" x1="3.10791" y1="-0.661257" x2="14.1232" y2="9.04996" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FE5B42" />
                <stop offset="1" stopColor="#BA0000" />
              </linearGradient>
            </defs>
          </svg>
        </Box>
      ),
    },
    {
      odds: '1.97',
      betType: 'black',  // Assuming club/spade SVG represents 'black'
      label: (
        <Box display="flex" justifyContent="center" gap={1}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12.0167 5.77483C11.8053 5.77483 11.605 5.79603 11.4159 5.81722C11.7942 5.23444 12.0167 4.5457 12.0167 3.81457C12.0167 1.70596 10.2253 0 8.01113 0C5.79694 0 4.00556 1.70596 4.00556 3.81457C4.00556 4.55629 4.22809 5.23444 4.6064 5.81722C4.40612 5.78543 4.20584 5.77483 4.00556 5.77483C1.79138 5.77483 0 7.48079 0 9.5894C0 11.698 1.79138 13.404 4.00556 13.404C5.363 13.404 6.55355 12.7576 7.27677 11.7828C7.32128 13.5417 6.7427 14.9298 5.61892 16H10.3811C9.26843 14.9298 8.68985 13.5417 8.72323 11.7828C9.44645 12.7576 10.637 13.404 11.9944 13.404C14.2086 13.404 16 11.698 16 9.5894C16 7.48079 14.2198 5.77483 12.0167 5.77483Z" fill="url(#paint0_linear_7166_23250)" />
            <defs>
              <linearGradient id="paint0_linear_7166_23250" x1="2.66737" y1="3.51682" x2="12.8332" y2="14.1928" gradientUnits="userSpaceOnUse">
                <stop stopColor="#454545" />
                <stop offset="1" />
              </linearGradient>
            </defs>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.7396 6.4L8.0015 0L1.26339 6.4C-0.421131 8 -0.421131 10.6057 1.26339 12.2057C2.92385 13.7829 5.57097 13.8057 7.25549 12.2971C7.1833 13.8286 6.60575 15.04 5.59503 16H10.3839C9.37318 15.04 8.79563 13.8057 8.72343 12.2971C10.408 13.8057 13.0791 13.7829 14.7155 12.2057C16.4241 10.5829 16.4241 8 14.7396 6.4Z" fill="url(#paint0_linear_7166_23251)" />
            <defs>
              <linearGradient id="paint0_linear_7166_23251" x1="3.10819" y1="4.64503" x2="12.397" y2="14.4222" gradientUnits="userSpaceOnUse">
                <stop stopColor="#454545" />
                <stop offset="1" />
              </linearGradient>
            </defs>
          </svg>
        </Box>
      ),
    },
  ];

  const miniCardSvgs = [
    {
      path: 'M4.68425 2L2.57859 0L0.472936 2C-0.0534785 2.5 -0.0534785 3.31429 0.472936 3.81429C0.99183 4.30714 1.81905 4.31429 2.34547 3.84286C2.32291 4.32143 2.14242 4.7 1.82657 5H3.32309C3.00724 4.7 3.17442 4.31429 3.15185 3.84286C3.67827 4.31429 4.51301 4.30714 5.02439 3.81429C5.55832 3.30714 5.55832 2.5 4.68425 2Z',
      gradientId: 'grad1_{id}',
      gradient: {
        x1: '1.04943',
        y1: '1.45157',
        x2: '3.9522',
        y2: '4.50693',
        stops: [
          { stopColor: '#454545' },
          { stopColor: '', offset: '1' },
        ],
      },
    },
    {
      path: 'M5.53906 2.5L3.03906 5L0.539062 2.5L3.03906 0L5.53906 2.5Z',
      gradientId: 'grad2_{id}',
      gradient: {
        x1: '1.58156',
        y1: '1.24857',
        x2: '4.05215',
        y2: '4.13092',
        stops: [
          { stopColor: '#FE5B42' },
          { stopColor: '#BA0000', offset: '1' },
        ],
      },
    },
    {
      path: 'M3.83334 1.80464C3.76728 1.80464 3.70469 1.81126 3.64558 1.81788C3.7638 1.63576 3.83334 1.42053 3.83334 1.19205C3.83334 0.533113 3.27354 0 2.5816 0C1.88967 0 1.32986 0.533113 1.32986 1.19205C1.32986 1.42384 1.3994 1.63576 1.51762 1.81788C1.45504 1.80795 1.39245 1.80464 1.32986 1.80464C0.63793 1.80464 0.078125 2.33775 0.078125 2.99669C0.078125 3.65563 0.63793 4.18874 1.32986 4.18874C1.75406 4.18874 2.12611 3.98676 2.35212 3.68212C2.36602 4.23179 2.18522 4.66556 1.83404 5H3.32221C2.97451 4.66556 2.7937 4.23179 2.80413 3.68212C3.03014 3.98676 3.40219 4.18874 3.82639 4.18874C4.51832 4.18874 5.07812 3.65563 5.07812 2.99669C5.07812 2.33775 4.5218 1.80464 3.83334 1.80464Z',
      gradientId: 'grad3_{id}',
      gradient: {
        x1: '0.911678',
        y1: '1.09901',
        x2: '4.0885',
        y2: '4.43524',
        stops: [
          { stopColor: '#454545' },
          { stopColor: '', offset: '1' },
        ],
      },
    },
    {
      path: 'M5.14234 0.45C4.61337 -0.15 3.76324 -0.15 3.23428 0.45L3.03906 0.671428L2.84385 0.45C2.31488 -0.15 1.46476 -0.15 0.935788 0.45C0.406821 1.05 0.406821 2.01429 0.935788 2.61429L3.03906 5L5.14234 2.61429C5.6713 2.01429 5.6713 1.04286 5.14234 0.45Z',
      gradientId: 'grad4_{id}',
      gradient: {
        x1: '1.51028',
        y1: '-0.206643',
        x2: '4.95256',
        y2: '2.82811',
        stops: [
          { stopColor: '#FE5B42' },
          { stopColor: '#BA0000', offset: '1' },
        ],
      },
    },
  ];
const mainRows = [
    { label: 'A. Don', values: ['15', '17'], betType: 'DON', selection: 'DON' },
    { label: 'B. Amar Akbar Anthony', values: ['5.15', '5.5'], betType: 'AAA', selection: 'AMAR_AKBAR_ANTHONY' },
    { label: 'C. Sahib Biwi Aur Ghulam', values: ['5.15', '5.5'], betType: 'SBAG', selection: 'SAHIB_BIBI_AUR_GHULAM' },
    { label: 'D. Dharam Veer', values: ['7.65', '8.35'], betType: 'DV', selection: 'DHARAM_VEER' },
    { label: 'E. Kis Kis Ko Pyaar Karu', values: ['3.85', '4.15'], betType: 'KKKPK', selection: 'KIS_KISKO_PYAAR_KAROON' },
    { label: 'F. Ghulam', values: ['5.15', '5.5'], betType: 'GHULAM', selection: 'GHULAM' },
];

  const Oddrows = [{ label: 'Odd',  values: ['1.32', '1.36'] }];

  const positions = ['Player', 'Banker'];

const cardData = [
    { id: 1, name: 'J', odds: '3.75', betType: 'SIDE', selection: 'CARD_J' },
    { id: 2, name: 'Q', odds: '3.75', betType: 'SIDE', selection: 'CARD_Q' },
    { id: 3, name: 'K', odds: '3.75', betType: 'SIDE', selection: 'CARD_K' },
    { id: 4, name: 'A', odds: '3.75', betType: 'SIDE', selection: 'CARD_A' },
];
  // Helper to format betType as per the provided logic (for gameId === 8)
  const formatBetType = (rawBetType) => {
    if (!rawBetType) return '';
    if (gameId !== 8) return rawBetType.toUpperCase(); // Default for other games

    const betTypeMap = {
      'don': 'DON_BACK',
      'aaa': 'AAA_BACK',
      'abag': 'SAHIB_BIBI_BACK',
      'dv': 'DHARAM_VEER_BACK',
      'kkkpk': 'KIS_KISKO_BACK',
      'ghulam': 'GHULAM_BACk',
      'don': 'DON_LAY',
      'aaa': 'AAA_LAY',
      'abag': 'SAHIB_BIBI_LAY',
      'dv': 'DHARAM_VEER_LAY',
      'kkkpk': 'KIS_KISKO_LAY',
      'ghulam': 'GHULAM_LAY',
    }

    return betTypeMap[rawBetType.toLowerCase()] || rawBetType.toUpperCase();
  };

const handleNumberBoxClick = (value, label, positionIndex, buttonType, rawBetType, selection = null, cardGuess = null) => {
    if (!locked) {
        let derivedBetType = rawBetType;
        let finalSelection = selection;

        const movieTypes = ['DON', 'AAA', 'SBAG', 'DV', 'KKKPK', 'GHULAM'];

        if (movieTypes.includes((rawBetType || '').toUpperCase())) {
            derivedBetType = buttonType === 'RedButton' ? 'LAY' : 'BACK';
        } 
        else if (label === 'Odd') {
            derivedBetType = buttonType === 'RedButton' ? 'LAY' : 'BACK';
            finalSelection = buttonType === 'BlueButton' ? 'ODD' : 'ODD';   // ← Fixed
            cardGuess = null;
        } 
        else {
            derivedBetType = rawBetType;
        }

        const betData = {
            userId: 357,                    // optional
            roundId: roundId,
            label: positionIndex !== undefined ? `${label} (${positions[positionIndex]})` : label,
            rate: parseFloat(value),
            odds: parseFloat(value), 
            buttonType,
            betType: derivedBetType,
            selection: finalSelection,      // ← Now correctly set
            cardGuess: cardGuess,
            stake: 0, // will be added later
        };

        setSelectedBet(betData);
        setBetDialogOpen(true);
        if (onBetSelect) onBetSelect(betData);
    }
};

  const handleBetScreenClose = () => {
    setBetDialogOpen(false);
    setSelectedBet(null);
  };

  const handleBetSubmit = (amount) => {
    const betData = {
      ...selectedBet,
      amount,
    };
    if (onBetSelect) {
      onBetSelect(betData);
    }
    handleBetScreenClose();
  };

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
   
    <Box className={styles.MatchScreen_container}>
    <Box sx={{ position: 'relative', width: '100%' }}>
  <GameScreen
    bettingClosed={socketData?.bettingClosed === true}
    animationTime={typeof socketData?.animationTime === 'number' ? socketData.animationTime : undefined}
    socketData={socketData}
    settledData={settledData}
    remainingTime={remainingTime}
  />
  <Box sx={{ position: 'absolute', bottom: '8px', right: '8px',  zIndex: 10}}>
    <FlipClock
      time={socketData?.bettingClosed ? 0 : (socketData?.remainingTime)}
    />
  </Box>
</Box>

      <Box className={styles.box}>
        <Box className={styles.box3}>
    {mainRows.map((row, rowIdx) => (
  <Box key={row.label} className={styles.casinoBox}>
    <Box className={styles.fontBox}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Typography className={styles.casinoCardText}>{row.label}</Typography>
        <ExposureLabel value={getExposureValue(row.selection)} />
      </Box>
    </Box>
       
    {row.values.map((val, i) => (
      <Box
        key={i}
        className={i === 0 ? styles.BlueButton : styles.RedButton}
        onClick={() => handleNumberBoxClick(
          val, row.label, i, 
          i === 0 ? 'BlueButton' : 'RedButton', 
          row.betType,     
          row.selection        
        )}
        sx={{ cursor: locked ? 'not-allowed' : 'pointer', position: 'relative' }}
      >
        <Typography className={styles.numberText}>{val}</Typography>
      
        {locked && (
          <Box className={styles.bettinglocked_icon_container}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
            </svg>
          </Box>
        )}
      </Box>
    ))}
  </Box>
))}
        </Box>
<Box className={styles.casinoBox2}>
  {Oddrows.map((row) => (
    <Box key={row.label} className={styles.casinoBox}>
      
      {/* Label + Exposure Below It */}
      <Box className={styles.fontBox}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={styles.casinoCardText}>{row.label}</Typography>
          
          {/* Exposure Value Label ke Niche */}
          <Box sx={{ display: 'flex', gap: '20px', marginTop: '4px' }}>
            <ExposureLabel value={getExposureValue('ODD')} />
       
          </Box>
        </Box>
      </Box>

      {/* Betting Boxes (Sirf Numbers) */}
      {row.values.map((val, i) => (
        <Box
          key={i}
          className={i === 0 ? styles.BlueButton : styles.RedButton}
          onClick={() => handleNumberBoxClick(
            val, 
            row.label, 
            i, 
            i === 0 ? 'BlueButton' : 'RedButton', 
            'ODD',
            null
          )}
          sx={{ 
            cursor: locked ? 'not-allowed' : 'pointer', 
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography className={styles.numberText}>{val}</Typography>

          {locked && (
            <Box className={styles.bettinglocked_icon_container}>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
              </svg>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  ))}
</Box>
        <Box className={styles.testbox}>
          <Box sx={{ width: '100% !important', alignSelf: 'stretch', marginBottom: '16px' }}>
            <Box className={styles.extraBets_container}>
              {buttonData.map((button, index) => (
                <Box
                  key={index}
                  sx={{
                    minWidth: '48%',
                    alignSelf: 'stretch',
                    position: 'relative',
                    '&:hover': {
                      cursor: locked ? 'not-allowed' : 'pointer',
                    },
                  }}
                >
                  <Typography className={styles.ButtonNoText}>{button.odds}</Typography>
                  <Box className={styles.bettingOptions_btn} onClick={() => handleNumberBoxClick(button.odds, button.label, undefined, 'special', button.betType)} sx={{ position: 'relative' }}>
                    <Typography className={styles.BlueButtonText}>{button.label}</Typography>
                 
                    {locked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                          <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                        </svg>
                      </Box>
                    )}

                  </Box>
                     <ExposureLabel value={getExposureValue(button.betType)} />
                </Box>
              ))}
              
            </Box>
          </Box>


          <Box sx={{ width: '100% !important', alignSelf: 'stretch', marginBottom: '16px' }}>
            <Typography className={styles.LastText}>3.75</Typography>
           <Box display="flex" flexWrap="wrap" className={styles.Cards_Section_container}>
  {cardData.map(({ id, name, odds, betType, selection }, index) => (
    <Box
      key={id}
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {/* Card box - stays exactly as it was, nothing added inside */}
      <Box
        className={styles.MiniCrads}
        onClick={() => handleNumberBoxClick(
          odds,
          name,
          undefined,
          'card',
          betType,
          selection,
          name
        )}
        sx={{ position: 'relative', justifyContent: 'center', '&:hover': { cursor: locked ? 'not-allowed' : 'pointer' } }}
      >
        <Box sx={{ alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', display: 'flex', textAlign: 'center' }}>
          <Typography className={styles.Cards_number}>{name}</Typography>
        </Box>
        <Box className={styles.MiniCardsInner}>
          <Box className={styles.MiniCardsInner2}>
            {/* SVG 1 */}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
              <path
                d="M4.68425 2L2.57859 0L0.472936 2C-0.0534785 2.5 -0.0534785 3.31429 0.472936 3.81429C0.99183 4.30714 1.81905 4.31429 2.34547 3.84286C2.32291 4.32143 2.14242 4.7 1.82657 5H3.32309C3.00724 4.7 2.82676 4.31429 2.8042 3.84286C3.33061 4.31429 4.16536 4.30714 4.67673 3.81429C5.21066 3.30714 5.21066 2.5 4.68425 2Z"
                fill={`url(#grad1_${id})`}
              />
              <defs>
                <linearGradient id={`grad1_${id}`} x1="1.04943" y1="1.45157" x2="3.9522" y2="4.50693" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#454545" />
                  <stop offset="1" />
                </linearGradient>
              </defs>
            </svg>
            {/* SVG 2 */}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
              <path
                d="M5.53906 2.5L3.03906 5L0.539062 2.5L3.03906 0L5.53906 2.5Z"
                fill={`url(#grad2_${id})`}
              />
              <defs>
                <linearGradient id={`grad2_${id}`} x1="1.58156" y1="1.24857" x2="4.05215" y2="4.13092" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#FE5B42" />
                  <stop offset="1" stopColor="#BA0000" />
                </linearGradient>
              </defs>
            </svg>
          </Box>
          <Box className={styles.MiniCardsInner2}>
            {/* SVG 3 */}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
              <path
                d="M3.83334 1.80464C3.76728 1.80464 3.70469 1.81126 3.64558 1.81788C3.7638 1.63576 3.83334 1.42053 3.83334 1.19205C3.83334 0.533113 3.27354 0 2.5816 0C1.88967 0 1.32986 0.533113 1.32986 1.19205C1.32986 1.42384 1.3994 1.63576 1.51762 1.81788C1.45504 1.80795 1.39245 1.80464 1.32986 1.80464C0.63793 1.80464 0.078125 2.33775 0.078125 2.99669C0.078125 3.65563 0.63793 4.18874 1.32986 4.18874C1.75406 4.18874 2.12611 3.98676 2.35212 3.68212C2.36602 4.23179 2.18522 4.66556 1.83404 5H3.32221C2.97451 4.66556 2.7937 4.23179 2.80413 3.68212C3.03014 3.98676 3.40219 4.18874 3.82639 4.18874C4.51832 4.18874 5.07812 3.65563 5.07812 2.99669C5.07812 2.33775 4.5218 1.80464 3.83334 1.80464Z"
                fill={`url(#grad3_${id})`}
              />
              <defs>
                <linearGradient id={`grad3_${id}`} x1="0.911678" y1="1.09901" x2="4.0885" y2="4.43524" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#454545" />
                  <stop offset="1" />
                </linearGradient>
              </defs>
            </svg>
            {/* SVG 4 */}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
              <path
                d="M5.14234 0.45C4.61337 -0.15 3.76324 -0.15 3.23428 0.45L3.03906 0.671428L2.84385 0.45C2.31488 -0.15 1.46476 -0.15 0.935788 0.45C0.406821 1.05 0.406821 2.01429 0.935788 2.61429L3.03906 5L5.14234 2.61429C5.6713 2.01429 5.6713 1.04286 5.14234 0.45Z"
                fill={`url(#grad4_${id})`}
              />
              <defs>
                <linearGradient id={`grad4_${id}`} x1="1.51028" y1="-0.206643" x2="4.95256" y2="2.82811" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#FE5B42" />
                  <stop offset="1" stopColor="#BA0000" />
                </linearGradient>
              </defs>
            </svg>
          </Box>
        </Box>

        {locked && (
          <Box className={styles.bettinglocked_icon_container}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
            </svg>
          </Box>
        )}
      </Box>

      {/* Exposure label OUTSIDE the card, below it */}
      <ExposureLabel value={getExposureValue(selection)} />
    </Box>
  ))}
</Box>
          </Box>
        </Box>
<FooterLinks
    socketData={socketData}
    settledData={settledData}
    gameType="Bollywood_Casino"
/>
      </Box>


    </Box>

  );
}

export default BollywoodCasino;